const initArticleComponent = () => {
    if (customElements.get('article-video-component')) return;

    window.onYouTubeIframeAPIReady = () => {
        document.dispatchEvent(new CustomEvent('ytIframeAPILoaded'));
    };

    class ArticleVideoComponent extends HTMLElement {
        constructor() {
            super();
            this.videoWrapper = this.querySelector('.video-wrapper');
            if (!this.videoWrapper) return;

            this.playButton = this.querySelector('.article-video--play-button');
            this.coverImage = this.querySelector('.article-video-cover');

            if (this.hasAttribute('data-inline')) {
                document.addEventListener('DOMContentLoaded', this.injectOnPlaceholder.bind(this), {
                    once: true
                });
            }
        }

        injectOnPlaceholder() {
            const componentPlaceholder = document.querySelector('[data-video-placeholder]');
            if (!componentPlaceholder) return;

            const partialBGContainer = this.closest('.partial-width-container-with-bg');
            if (this.classList.contains('full-width')) {
                componentPlaceholder.replaceWith(this);
            } else {
                componentPlaceholder.replaceWith(partialBGContainer);
            }
            this.removeAttribute('style');
        }

        isInViewPort(offsetPx = 0) {
            const position = this.getBoundingClientRect();
            return position.top >= 0 && position.bottom <= window.innerHeight;
        }
    }
    customElements.define('article-video-component', ArticleVideoComponent);
    class YoutubeEmbedComponent extends ArticleVideoComponent {
        constructor() {
            super();
            this.playerPlaceholder = this.querySelector('.player-placeholder');

            this.onPlayHandler = this.play.bind(this);
            this.playButton.addEventListener('click', this.onPlayHandler);

            this.scrollHandler = window.debounce(this.loadOnScroll.bind(this), 100);
            if (!this.isInViewPort()) {
                window.addEventListener('scroll', this.scrollHandler);
            } else {
                this.loadOnScroll();
            }
        }

        // instantiates the YT player
        createYTPlayer() {
            const height = this.dataset.height || '390';
            const width = this.dataset.width || '640';
            this.player = new YT.Player(this.playerPlaceholder, {
                height: height,
                width: width,
                videoId: this.dataset.videoId,
                playerVars: {
                    playsinline: 1,
                    rel: 0
                },
                events: {
                    onReady: this.onPlayerReady.bind(this)
                }
            });
        }

        // loads the yt iframe_api script
        loadYTIframeAPI() {
            if (document.querySelector('script.yt-api')) return;

            var tag = document.createElement('script');

            tag.classList.add('yt-api');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            document.addEventListener(
                'ytIframeAPILoaded',
                () => {
                    this.createYTPlayer();
                },
                {once: true}
            );
        }

        loadOnScroll() {
            if (!this.isInViewPort()) return;
            this.playButton.setAttribute('disabled', true);
            this.loadYTIframeAPI();

            window.removeEventListener('scroll', this.scrollHandler);
        }

        onPlayerReady() {
            this.playButton.removeAttribute('disabled');
        }

        play() {
            if (!this.player) return;

            this.player.playVideo();

            if (this.coverImage) this.coverImage.classList.add('hidden');
            if (this.playButton) this.playButton.classList.add('hidden');
        }
    }

    customElements.define('youtube-embed-component', YoutubeEmbedComponent);

    class TiktokEmbedComponent extends ArticleVideoComponent {
        constructor() {
            super();

            this.templateIframe = this.querySelector('template.iframe-template')?.content;
            if (!this.templateIframe) return;

            this.templateClone = this.templateIframe.cloneNode(true);

            this.onPlayHandler = this.play.bind(this);
            this.playButton.addEventListener('click', this.onPlayHandler);

            this.scrollHandler = window.debounce(this.loadContent.bind(this), 100);
            this.playButton.setAttribute('disabled', '');
            if (!this.isInViewPort()) {
                window.addEventListener('scroll', this.scrollHandler);
            } else {
                this.loadContent();
            }
        }

        play() {
            if (!this.iFrame) return;

            this.iFrame.contentWindow.postMessage(
                {type: 'play', value: '', 'x-tiktok-player': true},
                '*'
            );
        }

        hideCoverAndPlayButton() {
            if (this.coverImage) this.coverImage.classList.add('hidden');
            if (this.playButton) this.playButton.classList.add('hidden');
        }

        loadContent() {
            this.videoWrapper.prepend(this.templateClone);

            this.iFrame = this.querySelector('iframe');

            window.addEventListener('message', (event) => {
                // type: 'onStateChange', value: 1, x-tiktok-player: true
                if (!event.data['x-tiktok-player']) return;

                // event type == 'onStateChange' and
                if (event.data.type == 'onPlayerReady') {
                    this.playButton.removeAttribute('disabled');
                } else if (event.data.type == 'onStateChange' && event.data.value == 1) {
                    this.hideCoverAndPlayButton();
                }
            });
        }
    }
    customElements.define('tiktok-embed-component', TiktokEmbedComponent);

    class InstagramEmbedComponent extends ArticleVideoComponent {
        constructor() {
            super();
            this.templateIframe = this.querySelector('template.iframe-template')?.content;
            if (!this.templateIframe) return;

            this.templateClone = this.templateIframe.cloneNode(true);

            this.onPlayHandler = this.play.bind(this);
            this.playButton.addEventListener('click', this.onPlayHandler);
        }

        play() {
            if (!this.templateClone) return;

            this.videoWrapper.innerHTML = '';
            this.videoWrapper.append(this.templateClone);
        }
    }
    customElements.define('instagram-embed-component', InstagramEmbedComponent);
};

initArticleComponent();
// export default initArticleComponent;
